import { z } from 'zod'

const ownerSchema = z.object({
  ID: z.number(),
  Name: z.string(),
})

export const reportOnwerListSchema = z.array(ownerSchema)

const crawlerTaskSchema = z.object({
  status: z.enum(['running', 'succeeded', 'failed']),
  traceable_id: z.number(),
  traceable_type: z.enum(['report_kol', 'report_post']),
  media_type: z.enum([
    'IMAGE',
    'VIDEO',
    'facebook',
    'instagram',
    'youtube',
    'tiktok',
    'twitter',
  ]),
  updated_at: z.string().datetime(),
  exception: z
    .enum([
      'FETCH_POST_FAILED',
      'FETCH_COMMENT_FAILED',
      'FETCH_TIMEOUT',
      'TRIGGER_FAILED',
    ])
    .nullable(),
})
export const crawlerJobSchema = z.object({
  uuid: z.string().uuid(),
  status: z.enum(['running', 'succeeded', 'failed']),
  Tasks: z.array(crawlerTaskSchema),
  crawler_job_report: z.object({
    is_read: z.boolean(),
  }),
})

export const fetchReportCrawlerStatusResponseSchema = z.array(crawlerJobSchema)

const guestAssignmentSchenma = z.object({
  ID: z.number(),
  Email: z.string(),
  User: z.object({ Name: z.string() }).nullable(),
})

export const fetReportPermissionResponseSchema = z.object({
  WorkspaceName: z.string(),
  WorkspaceMemberAmount: z.number(),
  WorkspaceIconURL: z.string().nullable(),
  GuestAssignments: z.array(guestAssignmentSchenma),
})

// todo: pick by Report schema.
export const createReportResponseSchema = z.object({
  ID: z.number(),
})

const statisticsItemSchema = z.object({
  viewRate: z.number().nullish(),
  engagementRate: z.number().nullish(),
  type: z.string().nullish(),
})

export const fetchStatisticsSchema = z.object({
  statisticsAll: z.union([statisticsItemSchema, z.object({})]),
  statisticsCustom: z.union([statisticsItemSchema, z.object({})]),
})

const commentSchema = z.object({
  Comment: z.string(),
})

export const fetchCommentsResponseSchema = z.array(commentSchema)

const termSchema = z.object({
  ID: z.number(),
  Term: z.string(),
  IsInclude: z.boolean(),
})

export const fetchTermsResponseSchema = z.array(termSchema)

const termsFrequencySchema = z.object({
  Text: z.string(),
  Value: z.number(),
})
export const fetchTermsFrequencyResponseSchema = z.array(termsFrequencySchema)
